var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClockFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.94332 7.99992C8.94332 8.52059 8.52132 8.94258 8.00065 8.94258C7.47998 8.94258 7.05798 8.52059 7.05798 7.99992C7.05798 7.92658 7.06798 7.85659 7.08398 7.78792L5.24865 5.95258L5.36532 5.83525L5.83665 5.36392L5.95598 5.24525L7.79198 7.08192C7.85932 7.06659 7.92932 7.05725 8.00065 7.05725C8.07465 7.05725 8.14665 7.06792 8.21598 7.08392L10.8526 4.44725L11.56 5.15458L8.91998 7.79459C8.93398 7.86125 8.94332 7.92925 8.94332 7.99992ZM8.00065 1.33325C4.31865 1.33325 1.33398 4.31792 1.33398 7.99992C1.33398 11.6813 4.31865 14.6666 8.00065 14.6666C11.682 14.6666 14.6673 11.6813 14.6673 7.99992C14.6673 4.31792 11.682 1.33325 8.00065 1.33325Z",
    fill: "#185A7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockFilled);
export default __webpack_public_path__ + "static/media/clock-filled.6e1b7554afd8a5149041906b1b26f23e.svg";
export { ForwardRef as ReactComponent };